import type { PmNodeConverter, PmNodeJson } from './../pm-converters/types';
import type { FileData } from './../ricos-schema/legacy/wix/rich_content/v1';
import { Node_Type } from './../ricos-schema/legacy/wix/rich_content/v1';
import type { FileNode } from './../ricos-types';

export const fileUploadConverter: PmNodeConverter = {
  toPm: {
    types: [Node_Type.FILE],
    // @ts-ignore $TSFixMe
    convert: (node: FileNode) => ({
      type: Node_Type.FILE,
      attrs: {
        ...node.fileData,
        id: node.id,
      },
    }),
  },
  fromPm: {
    types: [Node_Type.FILE],
    convert: (node: PmNodeJson) => {
      const { id, ...data } = node.attrs || {};
      return {
        type: Node_Type.FILE,
        id,
        nodes: [],
        fileData: {
          ...(data as FileData),
        },
      };
    },
  },
};
